export default {
  unpaginated_elements: [],
  jevi_cuts: [],
  element: [],
  element_user: {},
  load_new: false,
  suggested_videos: [],
  resumable_video: null
}
